// src/components/tracking/PageTracker.jsx

import { useEffect } from 'react';
import { trackEvent } from '../../utils/tracking/trackEvent';

export default function PageTracker({ pageName }) {
  useEffect(() => {
    trackEvent('page_view', {
      page: pageName,
      path: window.location.pathname,
    });
  }, [pageName]);

  return null;
}